'use client';

import { DropdownIcon } from '../../dropdown-icon';

import styles from './FieldDropdownIcon.module.scss';

type FieldDropdownIconProps = {
  disabled?: boolean;
  error?: boolean;
  onClick: () => void;
};

export function FieldDropdownIcon({
  disabled,
  error,
  onClick,
}: FieldDropdownIconProps) {
  return (
    <span className={styles['icon']}>
      <DropdownIcon
        closed={false}
        disabled={disabled}
        error={error}
        onClick={onClick}
        aria-label="Toggle options"
      />
    </span>
  );
}
